import { styled } from "@material-ui/core";
import { useIO, useLinked } from "@type-r/react";
import { Column, Columns, Flex, Loading, PrimaryButton } from "lqx-react";
import React from "react";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { UploadFile } from "../../components/upload-file";
import { BackButton, CancelButton, ErrorView, ErrorsContainer, RightAlignedButtons, WorkflowBody, WorkflowFooter, WorkflowTitle } from "../../shared";

export const AddPolicyStep = ({ job, next, back, cancel }:
    { job: IngestionJob, next?, back?, cancel?}) => {
    const $file = useLinked(null);
    const $isValidPolicyFile = useLinked(false);
    const $doIngestionJobIO = useLinked(false);
    const isIngestionJobReady = useIO(
        async () => $doIngestionJobIO.isTruthy && await enqueueJobAndGoNext(),
        [$doIngestionJobIO.value]
    );

    const enqueueJobAndGoNext = async () => {
        try {
            await job.enqueue({ params: { file: $file.value, ...DocumentSource.Policy } });
            // policyFile.id = "4091617b-2433-49bc-960d-57be57968b61";
            await job.waitForEnqueueToBeDone();
            if (!job.hasErrors())
                next();
        } catch {
            job.reset();
        }
        finally {
            $doIngestionJobIO.set(false);
        }
    }

    return (isIngestionJobReady) ?
        <>
            <WorkflowTitle>
                Step 2: Add policy details
            </WorkflowTitle>
            <WorkflowBody>
                {job.hasErrors() && <ErrorsContainer><ErrorView>Failed to process the selected file.</ErrorView></ErrorsContainer>}
                <UploadFile $file={$file} $isValidFile={$isValidPolicyFile} />
            </WorkflowBody>
            <WorkflowFooter>
                <Columns>
                    <Column>
                        <CancelButton color="primary" onClick={cancel}>Cancel</CancelButton>
                    </Column>
                    <Column>
                        <RightAlignedButtons>
                            <BackButton color="primary" onClick={back}>Back: Choose Asset Type</BackButton>
                            <NextButton disabled={!$isValidPolicyFile.value} onClick={$doIngestionJobIO.true}>Next: Upload </NextButton>
                        </RightAlignedButtons>
                    </Column>
                </Columns>
            </WorkflowFooter>
        </> : <>
            <Flex center>
                <Loading />
            </Flex>
            <Flex center>
                {job.status && <WorkflowTitle>{job.status}</WorkflowTitle>}
            </Flex>
        </>
};

const NextButton = styled(PrimaryButton)({
    minWidth: '200px',
    minHeight: '25px',
    marginBottom: '10px',
});
